var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i18n',{attrs:{"tag":"p","path":"forgotPasswordConfirmation"}},[_c('span',{staticClass:"bold"},[_vm._t("email")],2)]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('Thank You Inbox')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }